export function getdata() {
	var obj = {
		headDataI: [{
				title: "税（费）种",
				prop: "tes1",
				width: "150px",
				custom: true,
			},
			{
				title: "征收品目",
				prop: "tes2",
				width: "150px",
				custom: true,
			},
			{
				title: "计税（费）依据",
				children: [{
					title: "消费税税额",
					prop: "xfs_7_x_1",
					width: "150px",
					custom: true,
				}]
			}, {
				title: "税（费）率（%）",
				prop: "xfs_7_x_2",
				width: "150px",
				custom: true,
			},
			{
				title: "本期应纳税（费）额",
				prop: "xfs_7_x_3",
				width: "150px",
				custom: true,
			},
			{
				title: "本期减免税（费）额",
				children: [{
					title: "减免性质代码",
					prop: "xfs_7_x_4",
					width: "150px",
					custom: true,
				}, {
					title: "减免税（费）额",
					prop: "xfs_7_x_5",
					width: "150px",
					custom: true,
				}]
			},

			{
				title: "小微企业“六税两费”减免政策",
				children: [{
					title: "减免性质",
					prop: "xfs_7_x_6",
					width: "150px",
					custom: true,
				}, {
					title: "减征比例（%）",
					prop: "xfs_7_x_7",
					width: "150px",
					custom: true,
				}, {
					title: "减征额",
					prop: "xfs_7_x_8",
					width: "150px",
					custom: true,
				}]
			}, {
				title: "本期已缴税（费）额",
				prop: "xfs_7_x_9",
				width: "150px",
				custom: true,
			}, {
				title: "本期应补（退）税（费）额",
				prop: "xfs_7_x_10",
				width: "150px",
				custom: true,
			},
		],

		tableDataI: [{}, {
				tes1: '城市维护建设税',
				tes2: "市区（消费税附征）",
				xfs_7_x_1: {
					cellCode: "xfs_7_1_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_2: {
					cellCode: "xfs_7_1_2",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_3: {
					cellCode: "xfs_7_1_3",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_4: {
					cellCode: "xfs_7_1_4",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_5: {
					cellCode: "xfs_7_1_5",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_6: {
					cellCode: "xfs_7_1_6",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_7: {
					cellCode: "xfs_7_1_7",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_8: {
					cellCode: "xfs_7_1_8",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_9: {
					cellCode: "xfs_7_1_9",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_10: {
					cellCode: "xfs_7_1_10",
					cellType: "1",
					cellVal: "0.00"
				},

			},
			{
				tes1: "教育费附加",
				tes2: "消费税教育费附加",
				xfs_7_x_1: {
					cellCode: "xfs_7_2_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_2: {
					cellCode: "xfs_7_2_2",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_3: {
					cellCode: "xfs_7_2_3",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_4: {
					cellCode: "xfs_7_2_4",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_5: {
					cellCode: "xfs_7_2_5",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_6: {
					cellCode: "xfs_7_2_6",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_7: {
					cellCode: "xfs_7_2_7",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_8: {
					cellCode: "xfs_7_2_8",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_9: {
					cellCode: "xfs_7_2_9",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_10: {
					cellCode: "xfs_7_2_10",
					cellType: "1",
					cellVal: "0.00"
				},

			},
			{
				tes1: "地方教育附加",
				tes2: "消费税地方教育附加",
				xfs_7_x_1: {
					cellCode: "xfs_7_3_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_2: {
					cellCode: "xfs_7_3_2",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_3: {
					cellCode: "xfs_7_3_3",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_4: {
					cellCode: "xfs_7_3_4",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_5: {
					cellCode: "xfs_7_3_5",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_6: {
					cellCode: "xfs_7_3_6",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_7: {
					cellCode: "xfs_7_3_7",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_8: {
					cellCode: "xfs_7_3_8",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_9: {
					cellCode: "xfs_7_3_9",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_10: {
					cellCode: "xfs_7_3_10",
					cellType: "1",
					cellVal: "0.00"
				},
			},
			{
				tes1: "合计",
				tes2: "- -",
				xfs_7_x_1: {
					cellCode: "xfs_7_4_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_2: {
					cellCode: "xfs_7_4_2",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_3: {
					cellCode: "xfs_7_4_3",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_4: {
					cellCode: "xfs_7_4_4",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_5: {
					cellCode: "xfs_7_4_5",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_6: {
					cellCode: "xfs_7_4_6",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_7: {
					cellCode: "xfs_7_4_7",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_8: {
					cellCode: "xfs_7_4_8",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_9: {
					cellCode: "xfs_7_4_9",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_7_x_10: {
					cellCode: "xfs_7_4_10",
					cellType: "1",
					cellVal: "0.00"
				},
			}
		],
		option1: [{
			label: "4363011701|43A031005005|易地扶贫搬迁项目免征地方教育费附加|《湖南省财政厅关于贯彻落实易地扶贫搬迁项目有关政策的通知》（湘财办〔2016〕26号）第二条第二款",
			value: "4363011701|43A031005005|易地扶贫搬迁项目免征地方教育费附加|《湖南省财政厅关于贯彻落实易地扶贫搬迁项目有关政策的通知》（湘财办〔2016〕26号）第二条第二款"
		}, {
			label: "0099011706|SXA031901333|保障性住房项目免收各项行政事业性收费和政府性基金|《财政部 税务总局 住房城乡建设部关于保障性住房有关税费政策的公告》 财政部 税务总局 住房城乡建设部公告2023年第70号第五条",
			value: "0099011706|SXA031901333|保障性住房项目免收各项行政事业性收费和政府性基金|《财政部 税务总局 住房城乡建设部关于保障性住房有关税费政策的公告》 财政部 税务总局 住房城乡建设部公告2023年第70号第五条"
		}, {
			label: "0099011801|SXA031901035|退役士兵从事个体经营扣减地方教育附加优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第一条",
			value: "0099011801|SXA031901035|退役士兵从事个体经营扣减地方教育附加优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第一条"
		}, {
			label: "0099011802|SXA031901036|企业招用退役士兵扣减地方教育附加优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第二条",
			value: "0099011802|SXA031901036|企业招用退役士兵扣减地方教育附加优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第二条"
		}, {
			label: "0099013601|SXA031901044|脱贫人口从事个体经营扣减地方教育附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条",
			value: "0099013601|SXA031901044|脱贫人口从事个体经营扣减地方教育附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条"
		}, {
			label: "0099013602|SXA031901027|登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生从事个体经营扣减地方教育附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条",
			value: "0099013602|SXA031901027|登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生从事个体经营扣减地方教育附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条"
		}, {
			label: "0099013603|SXA031901045|企业招用脱贫人口就业扣减地方教育附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条",
			value: "0099013603|SXA031901045|企业招用脱贫人口就业扣减地方教育附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条"
		}, {
			label: "0099013604|SXA031901028|企业招用登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生就业扣减地方教育附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条",
			value: "0099013604|SXA031901028|企业招用登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生就业扣减地方教育附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条"
		}, {
			label: "0099021901|SXA031900192|光伏发电免征政府性基金|《财政部关于对分布式光伏发电自发自用电量免征政府性基金有关问题的通知》 财综〔2013〕103号",
			value: "0099021901|SXA031900192|光伏发电免征政府性基金|《财政部关于对分布式光伏发电自发自用电量免征政府性基金有关问题的通知》 财综〔2013〕103号"
		}, {
			label: "0099042802|SXA031901054|除小规模纳税人外月（季）销售额小于10（30）万元免征地方教育附加|《财政部 国家税务总局关于扩大有关政府性基金免征范围的通知》 财税〔2016〕12号第一条第（一）款",
			value: "0099042802|SXA031901054|除小规模纳税人外月（季）销售额小于10（30）万元免征地方教育附加|《财政部 国家税务总局关于扩大有关政府性基金免征范围的通知》 财税〔2016〕12号第一条第（一）款"
		}, {
			label: "0099129999|SXA031999999|其他|其他",
			value: "0099129999|SXA031999999|其他|其他"
		}, ],
		
		option2: [{
			label: "6161010507|61A031005007|自主就业退役士兵创业优惠教育费附加|《陕西省财政厅等四部门转发财政部 国家税务总局 民政部关于调整完善扶持自主就业退役士兵创业就业有关税收政策的通知》（陕财税〔2014〕11号）",
			value: "6161010507|61A031005007|自主就业退役士兵创业优惠教育费附加|《陕西省财政厅等四部门转发财政部 国家税务总局 民政部关于调整完善扶持自主就业退役士兵创业就业有关税收政策的通知》（陕财税〔2014〕11号）"
		}, {
			label: "6161010513|61A031005013|重点群体就业优惠教育费附加|《陕西省关于继续实施支持和促进重点群体创业就业有关税收政策的通知》 陕财税【2014】14号",
			value: "6161010513|61A031005013|重点群体就业优惠教育费附加|《陕西省关于继续实施支持和促进重点群体创业就业有关税收政策的通知》 陕财税【2014】14号"
		}, {
			label: "4361011701|43A031005004|易地扶贫搬迁项目免征教育费附加|《湖南省财政厅关于贯彻落实易地扶贫搬迁项目有关政策的通知》（湘财办〔2016〕26号）第二条第二款",
			value: "4361011701|43A031005004|易地扶贫搬迁项目免征教育费附加|《湖南省财政厅关于贯彻落实易地扶贫搬迁项目有关政策的通知》（湘财办〔2016〕26号）第二条第二款"
		}, {
			label: "0061011701|SXA031901333|保障性住房项目免收各项行政事业性收费和政府性基金|《财政部 税务总局 住房城乡建设部关于保障性住房有关税费政策的公告》 财政部 税务总局 住房城乡建设部公告2023年第70号第五条",
			value: "0061011701|SXA031901333|保障性住房项目免收各项行政事业性收费和政府性基金|《财政部 税务总局 住房城乡建设部关于保障性住房有关税费政策的公告》 财政部 税务总局 住房城乡建设部公告2023年第70号第五条"
		}, {
			label: "0061011803|SXA031901033|退役士兵从事个体经营扣减教育费附加优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第一条",
			value: "0061011803|SXA031901033|退役士兵从事个体经营扣减教育费附加优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第一条"
		}, {
			label: "0061011804|SXA031901034|企业招用退役士兵扣减教育费附加优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第二条",
			value: "0061011804|SXA031901034|企业招用退役士兵扣减教育费附加优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第二条"
		}, {
			label: "0061013608|SXA031901042|脱贫人口从事个体经营扣减教育费附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条",
			value: "0061013608|SXA031901042|脱贫人口从事个体经营扣减教育费附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条"
		}, {
			label: "0061013609|SXA031901025|登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生从事个体经营扣减教育费附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条",
			value: "0061013609|SXA031901025|登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生从事个体经营扣减教育费附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条"
		}, {
			label: "0061013610|SXA031901043|企业招用脱贫人口就业扣减教育费附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条",
			value: "0061013610|SXA031901043|企业招用脱贫人口就业扣减教育费附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条"
		}, {
			label: "0061013611|SXA031901026|企业招用登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生就业扣减教育费附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条",
			value: "0061013611|SXA031901026|企业招用登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生就业扣减教育费附加|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条"
		}, {
			label: "0061042802|SXA031900783|按月纳税的月销售额或营业额不超过10万元缴纳义务人免征教育费附加|《财政部 国家税务总局关于扩大有关政府性基金免征范围的通知》 财税〔2016〕12号第一条",
			value: "0061042802|SXA031900783|按月纳税的月销售额或营业额不超过10万元缴纳义务人免征教育费附加|《财政部 国家税务总局关于扩大有关政府性基金免征范围的通知》 财税〔2016〕12号第一条"
		}, {
			label: "0061064002|SXA031900213|国家重大水利工程建设基金免征教育费附加|《财政部 国家税务总局关于免征国家重大水利工程建设基金的城市维护建设税和教育费附加的通知》 财税〔2010〕44号",
			value: "0061064002|SXA031900213|国家重大水利工程建设基金免征教育费附加|《财政部 国家税务总局关于免征国家重大水利工程建设基金的城市维护建设税和教育费附加的通知》 财税〔2010〕44号"
		}, {
			label: "0061129999|SXA031999999|其他|其他",
			value: "0061129999|SXA031999999|其他|其他"
		}, {
			label: "0061129999|SXA031900066|单位和个体经营者将货物捐赠给受灾地区的免征教育费附加|其他",
			value: "0061129999|SXA031900066|单位和个体经营者将货物捐赠给受灾地区的免征教育费附加|其他"
		}, {
			label: "0061129999|SXA031900687|上海期货交易所会员和客户通过上海期货交易所销售标准黄金,发生实物交割并已出库的，免征教育费附加|其他",
			value: "0061129999|SXA031900687|上海期货交易所会员和客户通过上海期货交易所销售标准黄金,发生实物交割并已出库的，免征教育费附加|其他"
		}, {
			label: "0061129999|SXA031900686|高校毕业生从事个体经营，扣减教育费附加|其他",
			value: "0061129999|SXA031900686|高校毕业生从事个体经营，扣减教育费附加|其他"
		}, {
			label: "0061129999|SXA031900685|除高校毕业生以外的失业人员从事个体经营，扣减教育费附加|其他",
			value: "0061129999|SXA031900685|除高校毕业生以外的失业人员从事个体经营，扣减教育费附加|其他"
		}, {
			label: "0061129999|SXA031900016|安置自谋职业的城镇退役士兵企业免征教育费附加|其他",
			value: "0061129999|SXA031900016|安置自谋职业的城镇退役士兵企业免征教育费附加|其他"
		}, {
			label: "0061129999|SXA031900681|被撤销金融机构清偿债务免征教育费附加|其他",
			value: "0061129999|SXA031900681|被撤销金融机构清偿债务免征教育费附加|其他"
		}, ],
		option3: [{
				label: "0007011803|SXA031901031|退役士兵从事个体经营扣减城市维护建设税优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第一条",
				value: "0007011803|SXA031901031|退役士兵从事个体经营扣减城市维护建设税优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第一条"
			}, {
				label: "0007011804|SXA031901032|企业招用退役士兵扣减城市维护建设税优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第二条",
				value: "0007011804|SXA031901032|企业招用退役士兵扣减城市维护建设税优惠|《财政部 税务总局 退役军人事务部关于进一步扶持自主就业退役士兵创业就业有关税收政策的公告》 财政部 税务总局 退役军人事务部公告2023年第14号 第二条"
			}, {
				label: "0007013610|SXA031901040|脱贫人口从事个体经营扣减城市维护建设税|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条",
				value: "0007013610|SXA031901040|脱贫人口从事个体经营扣减城市维护建设税|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条"
			}, {
				label: "0007013611|SXA031901023|登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生从事个体经营扣减城市维护建设税|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条",
				value: "0007013611|SXA031901023|登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生从事个体经营扣减城市维护建设税|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第一条"
			}, {
				label: "0007013612|SXA031901041|企业招用脱贫人口就业扣减城市维护建设税|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条",
				value: "0007013612|SXA031901041|企业招用脱贫人口就业扣减城市维护建设税|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条"
			}, {
				label: "0007013613|SXA031901024|企业招用登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生就业扣减城市维护建设税|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条",
				value: "0007013613|SXA031901024|企业招用登记失业半年以上人员，零就业家庭、享受城市低保登记失业人员，毕业年度内高校毕业生就业扣减城市维护建设税|《财政部 税务总局 人力资源社会保障部 农业农村部关于进一步支持重点群体创业就业有关税收政策的公告》财政部 税务总局 人力资源社会保障部 农业农村部公告2023年第15号 第二条"
			}, {
				label: "0007064002|SXA031900212|国家重大水利工程建设基金免征城市维护建设税|《财政部 国家税务总局关于免征国家重大水利工程建设基金的城市维护建设税和教育费附加的通知》 财税〔2010〕44号",
				value: "0007064002|SXA031900212|国家重大水利工程建设基金免征城市维护建设税|《财政部 国家税务总局关于免征国家重大水利工程建设基金的城市维护建设税和教育费附加的通知》 财税〔2010〕44号"
			}, {
				label: "0007129999|SXA031999999|其他|其他",
				value: "0007129999|SXA031999999|其他|其他"
			}, {
				label: "0007129999|SXA031900603|促进就业企业限额减免城市维护建设税|其他",
				value: "0007129999|SXA031900603|促进就业企业限额减免城市维护建设税|其他"
			}, {
				label: "0007129999|SXA031900409|受灾地区促进就业企业限额减免城市维护建设税|其他",
				value: "0007129999|SXA031900409|受灾地区促进就业企业限额减免城市维护建设税|其他"
			}, {
				label: "0007129999|SXA031900609|金融资产管理公司收购、承接、处置不良资产免征城市维护建设税|其他",
				value: "0007129999|SXA031900609|金融资产管理公司收购、承接、处置不良资产免征城市维护建设税|其他"
			}, {
				label: "0007129999|SXA031900602|被撤销金融机构财产用来清偿债务免征城市维护建设税|其他",
				value: "0007129999|SXA031900602|被撤销金融机构财产用来清偿债务免征城市维护建设税|其他"
			}, {
				label: "0007129999|SXA031900610|上海期货交易所会员和客户通过上海期货交易所销售标准黄金,发生实物交割并已出库的，免征城市维护建设税|其他",
				value: "0007129999|SXA031900610|上海期货交易所会员和客户通过上海期货交易所销售标准黄金,发生实物交割并已出库的，免征城市维护建设税|其他"
			}, {
				label: "0007129999|SXA031900608|黄金交易所会员单位免征城市维护建设税|其他",
				value: "0007129999|SXA031900608|黄金交易所会员单位免征城市维护建设税|其他"
			}, {
				label: "0007129999|SXA031900598|对国家石油储备基地第一期项目建设过程中涉及的城市维护建设税，予以免征|其他",
				value: "0007129999|SXA031900598|对国家石油储备基地第一期项目建设过程中涉及的城市维护建设税，予以免征|其他"
			}, {
				label: "0007129999|SXA031900599|文化单位转制为企业时的城市维护建设税优惠|其他",
				value: "0007129999|SXA031900599|文化单位转制为企业时的城市维护建设税优惠|其他"
			}, {
				label: "6107010506|61A031005006|自主就业退役士兵创业优惠城建税|《陕西省财政厅等四部门转发财政部 国家税务总局 民政部关于调整完善扶持自主就业退役士兵创业就业有关税收政策的通知》（陕财税〔2014〕11号）",
				value: "6107010506|61A031005006|自主就业退役士兵创业优惠城建税|《陕西省财政厅等四部门转发财政部 国家税务总局 民政部关于调整完善扶持自主就业退役士兵创业就业有关税收政策的通知》（陕财税〔2014〕11号）"
			}, {
				label: "6107010512|61A031005012|重点群体就业优惠城建税|《陕西省关于继续实施支持和促进重点群体创业就业有关税收政策的通知》 陕财税【2014】14号",
				value: "6107010512|61A031005012|重点群体就业优惠城建税|《陕西省关于继续实施支持和促进重点群体创业就业有关税收政策的通知》 陕财税【2014】14号"
			},

		],
	}
	return obj
}